import React from 'react'
import PropTypes from 'prop-types'
import RaisedButton from 'material-ui/RaisedButton'
import { browserHistory } from 'react-router'
import HeartIcon from 'material-ui/svg-icons/action/favorite' 
import { homepageDir } from '../../../../constant/wxConfig';
import Background from '../../../components/Background'
import './SpeakOut.css'

class User extends React.Component {

  render = () => {
    return (
      <div className='speakout-container' >
        <div className='speakout-title'>
          十年了，我想对汶川说
        </div>
        <div className='speakout-main'>
          汶川地震，十年之际，来讲述，来倾听那些曾经触动你的一点一滴。
          <br/><br/>
          或许并非惊涛骇浪，但细微之处，同样直击内心。
          <br/><br/>
          十年了，你与汶川从来不曾是平行线。进来讲述那些你和汶川的交点。
        </div>
        <div className="speakout-button-container" >
          <RaisedButton
            label='表白卧龙'
            style={{ borderRadius:30 }}
            buttonStyle={{ 
              borderRadius:30,
              height:'100%',
              padding:'5px 10px'
              }}
            labelStyle={{ fontSize:18 }}
            backgroundColor='#ff7876'
            labelColor='white'
            icon={<HeartIcon color='white'
              style={{ width:16, height:16 }} />}
            onClick={this.props.hidePoster} />
        </div>
      </div>
    )
  }
}

export default User



// WEBPACK FOOTER //
// ./src/layouts/PageLayout/Poster/index.js